import { render, staticRenderFns } from "./MspRemuSocle.vue?vue&type=template&id=a9a66da2&scoped=true&"
import script from "./MspRemuSocle.vue?vue&type=script&lang=ts&"
export * from "./MspRemuSocle.vue?vue&type=script&lang=ts&"
import style0 from "./MspRemuSocle.vue?vue&type=style&index=0&id=a9a66da2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a66da2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import DatePicker from '@cnamts/vue-dot/src/patterns/DatePicker'
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {DatePicker,VCol,VContainer,VDivider,VSimpleTable})
